import clsx from "clsx";
import React, { createContext, useContext } from "react";
import { Button, Container } from "react-bootstrap";
import { useCurriculum } from "./hooks";
import { NewSectionButton } from "./NewSectionButton";
import { SectionItem } from "@components";
// import PropTypes from "prop-types";
import styles from "./style/CurriculumTab.module.css";
import { TabTitle } from "@components";
import { useDispatch, useSelector } from "react-redux";
import { startsWith } from "lodash";
import { editingCourseActions, updateCourseAction } from "@redux/actions";
import { CourseContext } from "..";
import { toast } from "react-toastify";

const CurriculumContext = createContext();

const CurriculumTab = () => {
  const curriculum = useCurriculum();
  const { sections, handleAddSection } = curriculum;
  const { step, setStep, isUpdate, autoSave, setAutoSave } =
    useContext(CourseContext);

  const dispatch = useDispatch();

  const hasNoSection =
    sections.filter((section) => section.isDeleted != true).length == 0;

  const hasNoUnit =
    sections.filter((section) => {
      if (section.isDeleted) {
        return false;
      }
      return section.units.filter((unit) => unit.isDeleted != true).length == 0;
    }).length > 0;

  const processingList = useSelector(
    (state) => state.course.addLecture.processingList
  );

  const isLoading = processingList.some((item) => item.processing == true);

  const handleSaveChange = () => {
    // await dispatch(editingCourseActions.splitUnits());
    dispatch(updateCourseAction());
  };

  return (
    <div>
      <CurriculumContext.Provider value={curriculum}>
        <TabTitle
          onSave={handleSaveChange}
          isAutoSave={autoSave}
          setAutoSave={setAutoSave}
        >
          <i className="bi bi-collection mr-2"></i>Curriculum
        </TabTitle>

        <div
          className={clsx(
            "d-flex border align-items-center p-3",
            styles.titleContainer
          )}
        >
          <div className={styles.title}>
            <i className="bi bi-list-ul mr-2"></i>
            <h5 className="m-0">Curriculum</h5>
          </div>
          <NewSectionButton onSubmit={handleAddSection} />
        </div>

        <div className={styles.sectionsContainer}>
          {sections.map((section, index) => {
            return (
              <SectionItem
                key={section.id}
                id={section.id}
                title={section.title}
                lectures={section.lectures}
                sectionData={section}
                isDeleted={section.isDeleted}
              />
            );
          })}
        </div>
        <div className=" d-flex justify-content-between align-items-center mt-5">
          <Button
            onClick={() => {
              setStep(step - 1);
            }}
            disabled={step == 1 ? true : false}
          >
            Prev
          </Button>

          <span className="">
            {(() => {
              if (hasNoSection) {
                return "You must have at least 1 section";
              } else if (hasNoUnit) {
                return "You must have at least 1 unit (lecture, quiz or document) for each section";
              }
            })()}
          </span>

          <Button
            onClick={() => {
              handleSaveChange();
              setStep(step + 1);
            }}
            disabled={isLoading || hasNoSection || hasNoUnit}
          >
            Next
          </Button>
        </div>
      </CurriculumContext.Provider>
    </div>
  );
};

/* required: display name */
CurriculumTab.displayName = "CurriculumTab";

/* required: props types */
CurriculumTab.propTypes = {};

/* required: default props */
CurriculumTab.defaultProps = {};

export { CurriculumTab, CurriculumContext };
